﻿import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { ngfModule } from "angular-file";
import { AppComponent } from './app.component';
import { NavMenuComponent } from './navmenu/navmenu.component';
import { HomeComponent } from './home/home.component';
import { SharedModule } from './shared.module';
import { NavigationFocus } from './shared/navigation-focus';
import { ReportComponent } from './report/report.component';
import { MATERIAL_SANITY_CHECKS } from '@angular/material';
// import {
//     AuthModule,
//     OidcSecurityService,
//     OpenIDImplicitFlowConfiguration,
//     OidcConfigService,
//     AuthWellKnownEndpoints
// } from 'angular-auth-oidc-client';
import { AuthInterceptor } from './auth.interceptor';
import { Configuration } from './app.constants';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { SafeHtmlPipe } from "./pipe.safehtml";
import { OAuthService, OAuthModule } from 'angular-oauth2-oidc';
import { AuthGuard } from './models/AuthGuard';
import { authConfig } from './models/AuthConfig';
import { LoadConfigService } from './shared/load-config.service';

// export function loadConfig(oidcConfigService: OidcConfigService) {
//     return () => oidcConfigService.load("/settings");
// }

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        ReportComponent,
        NavigationFocus,
        SafeHtmlPipe
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        CommonModule,
        HttpClientModule,
        // AuthModule.forRoot(),
        FormsModule,
        SharedModule,
        ngfModule,
        RouterModule.forRoot([
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'report/:conversionId', component: ReportComponent, canActivate:[AuthGuard] },
            { path:"**", redirectTo:'/'}
        ]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        OAuthModule.forRoot()
    ],
    providers: [
        // OidcConfigService,
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: loadConfig,
        //     deps: [OidcConfigService],
        //     multi: true
        // },
        LoadConfigService,
        AuthGuard,
        { provide: MATERIAL_SANITY_CHECKS, useValue: false },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        Configuration
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(
        // private oidcSecurityService: OidcSecurityService,
        // private oidcConfigService: OidcConfigService,
       // private _config: Configuration
    ) {
        //_config.Server = authConfig.issuer;
        console.log('APP STARTING');
    }
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
